import { SearchResultListItem } from "@/components/layout/Navbar/ApplicationSearch/SearchBar/SearchResultMenu/SearchResultListItem";
import { getSortValuePart } from "@/components/layout/Navbar/ApplicationSearch/SearchBar/SearchResultMenu/search-result-menu.utils";
import { PartRow, SearchResultItem } from "@/components/layout/Navbar/ApplicationSearch/application-search.types";
import { routes } from "@/routes";
import { generatePath } from "@/routes/routes.utils";

type Props = {
    data: PartRow;
    onClick: (item: SearchResultItem) => void;
    isRecentSearch?: boolean;
    className?: string;
};

export const PartListItem = (props: Props) => {
    const { data } = props;

    const item: SearchResultItem = {
        type: "part",
        data,
        sortValue: getSortValuePart(data),
    };

    return (
        <SearchResultListItem
            label={data.PartNumber}
            chip={data.PartDescription}
            title={"Part"}
            // @ts-expect-error FIXME: link can be undefined
            url={generatePath(routes.partDetail, {
                params: { partNumber: data.PartNumber },
            })}
            icon={"lely-icon-gear"}
            onClick={() => props.onClick(item)}
            isRecentSearch={props.isRecentSearch}
            className={props.className}
        />
    );
};
